var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-popover",
        { attrs: { placement: "top-start", trigger: "hover" } },
        [
          _vm.content.length > 0
            ? _c(
                "div",
                _vm._l(_vm.content, function(item) {
                  return _c("p", { key: item, staticClass: "content" }, [
                    _vm._v(_vm._s(item))
                  ])
                }),
                0
              )
            : _vm._e(),
          _c("span", { attrs: { slot: "reference" }, slot: "reference" }, [
            _vm._v(_vm._s(_vm.shortContent))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }